import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  props: ['editedPeriod'],
  data () {
    return {
      loading: false,
      isUpdatablePeriod: false,
      listEcheances: []
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    async deletePeriode () {
      this.loading = true
      this.editedPeriod.updateUser = this.$store.state.user.user.login
      this.$store.dispatch('periode/deletePeriode', this.editedPeriod).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/periode/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    format_date_courte (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    }
  },
  mounted () {
    if (this.editedPeriod && this.editedPeriod.periodeId) {
      this.$store.dispatch('user/selectPeriode', this.editedPeriod)
      this.loading = true
      this.$store.dispatch('user/isPeriodeUpdatable', this.editedPeriod.periodeId).then(
        response => {
          this.loading = false
          this.isUpdatablePeriod = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    } else {
      this.$router.push({ name: 'administration/periode/list' })
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Détails de la période'
    this.$store.state.filArianeMiddlePage = 'Liste des périodes'
    this.$store.state.filArianeMiddleRouterLink = 'administration/periode/list'
  }
}
